import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Tag, Truck, Package, Droplets } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import Breadcrumbs, { toLdItems } from "@/components/Breadcrumbs";
import { buildBreadcrumbLd } from "@/lib/seo";
import { useSeoT, PAGE_META } from "@/lib/seoPagesI18n";

const CARDS = [
  { slug: "demenagement", icon: Truck },
  { slug: "debarras", icon: Package },
  { slug: "nettoyage-fin-de-bail", icon: Droplets },
];

export default function TarifsIndex() {
  const navigate = useNavigate();
  const { t: st, lang } = useSeoT();
  const meta = (PAGE_META[lang] || PAGE_META.fr).tarifs;
  const tt = st.tarifs;
  const bc = [{ name: st.bc.home, path: "/" }, { name: st.bc.tarifs, path: "/tarifs" }];
  return (
    <div className="min-h-screen bg-white text-[#0A0F2C]" data-testid="tarifs-index">
      <Seo title={meta.title} description={meta.desc} path="/tarifs" jsonLd={buildBreadcrumbLd(toLdItems(bc))} />
      <Header />
      <section className="relative bg-[#2D5BFF] hero-noise overflow-hidden pt-28 md:pt-36 pb-14 md:pb-20 px-5 sm:px-8 md:px-10 lg:px-14 text-white">
        <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(ellipse at top right, rgba(255,255,255,0.15), transparent 55%)" }} />
        <div className="relative mx-auto" style={{ maxWidth: "1280px" }}>
          <div className="mb-6"><Breadcrumbs items={bc} variant="dark" /></div>
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1 text-[11px] uppercase tracking-[0.22em] text-[#FFD84D] font-bold mb-5"><Tag size={12} /> {tt.badge}</span>
          <h1 className="font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.02] max-w-3xl" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{tt.h1}</h1>
          <p className="mt-5 text-white/85 text-base md:text-lg max-w-2xl">{tt.intro}</p>
        </div>
      </section>
      <section className="py-16 md:py-24 px-5 sm:px-8 md:px-10 lg:px-14 bg-white">
        <div className="mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" style={{ maxWidth: "1280px" }}>
          {CARDS.map((c) => {
            const Ic = c.icon;
            const cc = tt.cards[c.slug];
            return (
              <Link key={c.slug} to={`/tarifs/${c.slug}`} className="group bg-[#F7F7F8] hover:bg-[#EAF0FF] rounded-3xl p-7 transition-colors" data-testid={`tarifs-card-${c.slug}`}>
                <div className="w-11 h-11 rounded-xl bg-white text-[#2D5BFF] inline-flex items-center justify-center shadow-sm"><Ic size={20} /></div>
                <h2 className="mt-4 font-extrabold text-xl text-[#0A0F2C] group-hover:text-[#2D5BFF] transition-colors" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{cc.name}</h2>
                <p className="mt-2 text-[14px] text-[#4B5563] leading-relaxed">{cc.desc}</p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-[#2D5BFF] font-bold text-sm">{tt.cardCta} <ArrowRight size={14} /></div>
              </Link>
            );
          })}
        </div>
        <div className="mx-auto mt-12 text-center" style={{ maxWidth: "900px" }}>
          <button onClick={() => navigate("/devis")} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#0A0F2C] hover:bg-[#1a2050] text-white px-7 py-4 font-extrabold text-sm md:text-base transition-all" data-testid="tarifs-cta-quote">
            {tt.indexCta} <ArrowRight size={18} />
          </button>
        </div>
      </section>
      <Footer />
    </div>
  );
}
